import { useCallback, useContext } from 'react';
import { fileToObject } from '../utils/utils';
import { UploadStateContext } from '../context';
export const useOnStart = () => {
    const { setValue } = useContext(UploadStateContext);
    return useCallback((_file) => {
        const file = fileToObject(_file, { status: 'idle' });
        setValue((prev) => [...prev, file]);
    }, [setValue]);
};
